import * as React from "react";

function SvgUndrawReminders697P(props: any) {
  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width="959.26162"
      height="684.45681"
      viewBox="0 0 959.262 684.457"
      {...props}
    >
      <path
        d="M470.463 0L207.361 142.511a66.93 66.93 0 11-117.65 63.726L0 254.83l232.378 429.012 470.463-254.83z"
        fill="#f2f2f2"
      />
      <path
        fill="#3f51b5"
        d="M137.144 333.711l189.613 30.182-15.405 96.782-148.135-23.58-5.973 37.528-12.144-40.411-23.361-3.719 15.405-96.782z"
      />
      <path
        opacity={0.2}
        d="M137.144 333.711l189.613 30.182-15.405 96.782-148.135-23.58-5.973 37.528-12.144-40.411-23.361-3.719 15.405-96.782z"
      />
      <path
        fill="#f2f2f2"
        d="M283.886 391.497l-114.558-18.234 1.572-9.876 114.558 18.235zM280.74 411.248l-114.557-18.235 1.572-9.876 114.558 18.235zM277.597 431l-114.558-18.235 1.572-9.876 114.558 18.235z"
      />
      <path
        fill="#3f51b5"
        d="M124.156 472.652l176.225-76.216 38.902 89.948-137.676 59.544 15.084 34.877-31.921-27.595-21.712 9.39-38.902-89.948z"
      />
      <path
        fill="#f2f2f2"
        d="M279 442.726l-106.47 46.047-3.969-9.178 106.47-46.047zM286.939 461.084l-106.47 46.047-3.969-9.178 106.47-46.047zM294.875 479.44l-106.47 46.047-3.969-9.178 106.47-46.048z"
      />
      <path
        fill="#3f51b5"
        d="M151.156 296.652l176.225-76.216 38.902 89.948-137.676 59.544 15.084 34.877-31.921-27.595-21.712 9.39-38.902-89.948z"
      />
      <path
        fill="#f2f2f2"
        d="M306 266.726l-106.47 46.047-3.969-9.178 106.47-46.047zM313.939 285.084l-106.47 46.047-3.97-9.178 106.47-46.047zM321.876 303.44l-106.47 46.048-3.97-9.179 106.47-46.047z"
      />
      <path
        d="M164.592 78.957l704.91 30.124s110.456 351.451 28.116 502.073l-667.757 73.303s140.58-261.078-65.27-605.5z"
        fill="#3f3d56"
      />
      <path
        fill="none"
        stroke="#2f2e41"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M272.035 242.633l594.455-10.042M288.102 288.823l600.479-12.049M178.866 103.694l696.284 24.484"
      />
      <path
        d="M702.682 463.547c0 1.49-.01 2.98-.05 4.45v.01c-.06 3.64-.2 7.22-.43 10.78q-.36 5.73-.98 11.31c-4.05 36.37-16.27 68.06-33.42 89.72-9.72 12.29-21.03 21.36-33.34 26.24a58.449 58.449 0 01-11.65 3.29 55.128 55.128 0 01-9.37.8c-14.73 0-28.63-5.86-40.87-16.26-23.65-20.05-41.15-56.97-46.58-101.08v-.01c-.92-7.46-1.5-15.11-1.69-22.93q-.09-3.135-.09-6.32c0-80.97 39.95-146.61 89.23-146.61 11.67 0 22.82 3.68 33.04 10.38.3.19.6.39.89.6a86.977 86.977 0 0115.35 13.38 112.596 112.596 0 018.24 10.15 134.249 134.249 0 018.92 14.22c2.24 4.1 4.35 8.42 6.29 12.93v.01q3.03 6.96 5.55 14.5v.01a214.027 214.027 0 019.86 47.41c.73 7.5 1.1 15.19 1.1 23.02z"
        opacity={0.2}
      />
      <path
        d="M219.27 90.501c.765 2.868-.153 6.195-2.047 7.429-1.889 1.23-4.034-.09-4.796-2.946s.146-6.177 2.032-7.42c1.89-1.244 4.046.07 4.81 2.937zM235.312 90.25c.765 2.868-.153 6.195-2.046 7.429-1.89 1.23-4.035-.09-4.797-2.946s.147-6.177 2.033-7.42c1.89-1.244 4.045.07 4.81 2.937zM203.227 90.752c.765 2.868-.153 6.195-2.046 7.429-1.89 1.23-4.035-.09-4.797-2.946s.147-6.177 2.033-7.42c1.89-1.244 4.045.07 4.81 2.937z"
        fill="#3f51b5"
      />
      <path
        d="M704.025 379.014l5.191 15.445 5.62.434-5.052-38.503c1.877-24.319-8.275-45.773-32.593-47.65a30.837 30.837 0 00-33.119 28.372l-2.868 37.157a14.896 14.896 0 0013.705 15.998l43.6 3.365z"
        fill="#2f2e41"
      />
      <path
        d="M709.506 466.982s4.616 12.528 12.528 14.506 66.597 15.825 66.597 15.825 51.431 1.319 35.606 12.528-41.54 0-41.54 0-75.169-9.23-81.103-19.121a133.286 133.286 0 01-9.891-21.1z"
        fill="#fbbebe"
      />
      <path
        d="M684.45 411.595s37.584 61.321 32.969 62.64-47.475 15.166-49.453 9.89-1.979-29.671-1.979-29.671z"
        fill="#ff6584"
      />
      <path
        d="M684.45 411.595s37.584 61.321 32.969 62.64-47.475 15.166-49.453 9.89-1.979-29.671-1.979-29.671z"
        opacity={0.15}
      />
      <path
        d="M581.192 391.298l-55.787 77.568s-37.096 33.133-23.193 37.112 35.97-28.107 35.97-28.107l64.3-81.199zM695.66 362.8s-16.485 25.057-15.166 30.991c0 0-1.32 3.957.659 6.594s1.319 18.463 1.319 18.463l-6.594 9.23-8.572-28.352-3.956-30.331s8.901-12.199 7.583-18.133 24.726 11.539 24.726 11.539z"
        fill="#fbbebe"
      />
      <path
        d="M667.802 579.817c-9.72 12.29-21.03 21.36-33.34 26.24a58.449 58.449 0 01-11.65 3.29c2.11-46.81 4.54-88.56 6.25-92.25 3.96-8.57 14.51-11.87 14.51-11.87s1.04 2.79 2.78 7.64c4.51 12.64 13.73 39.28 21.45 66.95z"
        fill="#ff6584"
      />
      <path
        d="M667.802 579.817c-9.72 12.29-21.03 21.36-33.34 26.24a58.449 58.449 0 01-11.65 3.29c2.11-46.81 4.54-88.56 6.25-92.25 3.96-8.57 14.51-11.87 14.51-11.87s1.04 2.79 2.78 7.64c4.51 12.64 13.73 39.28 21.45 66.95z"
        opacity={0.15}
      />
      <circle cx={687.087} cy={342.36} r={24.397} fill="#fbbebe" />
      <path
        d="M676.542 455.117c-4.56 4.34-7.91 7.54-10.37 9.98-5 4.94-6.34 6.71-6.78 8.48-.66 2.64-3.95 2.64-3.95 2.64l-9.09 36.65-10.04 40.49s-.65 22.5-1.85 52.7a58.449 58.449 0 01-11.65 3.29 55.128 55.128 0 01-9.37.8c-14.73 0-28.63-5.86-40.87-16.26.17-38.62-.22-78.11-.22-78.11s-10.55-17.14 25.72-50.77c0 0 5.72-16.68 11.64-33.43 5.95-16.88 12.1-33.83 12.76-33.83.44 0 3.59-4.03 7.59-9.4 3.51-4.7 7.68-10.44 11.24-15.41 4.59-6.36 8.2-11.45 8.2-11.45s10.83 0 15.47 5.53a8.505 8.505 0 011.68 3.04c1.12 3.65 3.68 12.56 6.25 21.6 3.45 12.17 6.93 24.55 6.93 24.55l1.77-14.88s5.49 7.63 5.49 13.56c0 .32.01.68.02 1.09.29 7.11 2.52 26.66-10.57 39.14z"
        fill="#ff6584"
      />
      <path
        d="M657.416 366.757l-7.913-5.275s-32.969 19.781-56.047 21.1-22.419 14.506-13.187 23.738 45.497 40.88 46.815 32.968 30.332-72.531 30.332-72.531z"
        fill="#ff6584"
      />
      <path
        d="M700.883 311.91c-5.303-1.789-18.132-2.74-20.009-2.886a34.531 34.531 0 00-37.086 31.772l-16.692 47.325 25.23 1.947 6.067-17.585 5.262 18.46 12.7.98 1.924-10.7 3.466 11.116 14.147 1.091c-8.745-24.79-12.694-47.077 2.267-59.49 9.3 2.006 17.422.1 19.107-4.896 1.942-5.756-5.393-13.427-16.383-17.134z"
        fill="#2f2e41"
      />
      <path fill="#3f51b5" d="M767.262 367.957h192v98h-150v38l-18.345-38h-23.655v-98z" />
      <path
        fill="#f2f2f2"
        d="M921.261 401.957h-116v-10h116zM921.261 421.957h-116v-10h116zM921.261 441.957h-116v-10h116z"
      />
      <path
        fill="#3f51b5"
        opacity={0.2}
        d="M560.22 142.874l48.306 12.905-12.904 48.306-48.306-12.905z"
      />
      <circle
        cx={591.037}
        cy={193.867}
        r={14.756}
        fill="none"
        stroke="#3f3d56"
        strokeMiterlimit={10}
        strokeWidth={2}
      />
    </svg>
  );
}

export default SvgUndrawReminders697P;
